"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertArrayToObjectByKey = convertArrayToObjectByKey;
function convertArrayToObjectByKey(array, key) {
    return array.reduce((accumulator, currentItem) => ({ ...accumulator, [currentItem[key]]: currentItem }), {});
}
